import {IUploadImage} from '../../../models/utilities/uploadImage';

import Uploader from './uploader';

type TUploadImageProps = {
  images: Array<IUploadImage>;
  setImages: React.Dispatch<React.SetStateAction<IUploadImage[]>>;
};

const UploadImage = ({images, setImages}: TUploadImageProps) => {
  return (
    <>
      <div className="mt-1">
        <Uploader images={images} setFile={setImages} />
        {/* {images && images.length > 0 && (
          <Images images={images} setFile={setImages} />
        )} */}
      </div>
    </>
  );
};

export default UploadImage;
